import { render, staticRenderFns } from "./product-supliers-tab.vue?vue&type=template&id=d8522436"
import script from "./product-supliers-tab.vue?vue&type=script&lang=js"
export * from "./product-supliers-tab.vue?vue&type=script&lang=js"
import style0 from "./product-supliers-tab.vue?vue&type=style&index=0&id=d8522436&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports